// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2000) return "static/chunks/e8867c6f-ddfde29023a61559.js";
	if (chunkId === 1539) return "static/chunks/d5acec9f-72e07f80763b9391.js";
	if (chunkId === 421) return "static/chunks/7566a6ad-da195faf876607a5.js";
	if (chunkId === 7913) return "static/chunks/7913-402e9d2917118a0a.js";
	if (chunkId === 9373) return "static/chunks/9373-f447fa5c8d7a9fdb.js";
	if (chunkId === 2978) return "static/chunks/2978-b17aab09f5a07ff1.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4023 ? "8be61527" : chunkId) + "." + {"1595":"004c402e3c13035c","1789":"19381466f8f64391","2989":"eb77561dbf2e85bf","3400":"0a3d719a19f71ca7","4023":"51ce9f7d42bb9baa","4120":"2c2aacae54bdb7e2","6682":"7ef2da9bb3d1a98c"}[chunkId] + ".js";
};